var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("© "+_vm._s(new Date().getFullYear())+" | Conscius Bedrijfsrevisoren | Gentsebaan 71A, bus 101 | 9100 Sint-Niklaas | Tel.: +32(0)3 777 75 79 | Email: info@conscius-audit.eu")])])}
var staticRenderFns = []

export { render, staticRenderFns }